module.exports = __webpack_public_path__ + "static/home_mobile-33093b9dfde1fd9923fd0eda0c16833b.png";